import React from 'react';
import { useSelector } from 'react-redux';
import Button from '../common/Button';
import Loading from '../common/Loading';
import { RootState } from '../../redux/store';

interface PrivacyPolicyModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ isOpen, onClose, onConfirm }) => {
    const customerLegal = useSelector((state: RootState) => state.customerLegal);
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[5%] mx-auto w-4/5 max-w-4xl p-5 border-[#888] rounded text-left text-black max-h-[90vh] overflow-y-auto">
                <div className="modal-content">
                    <div className="flex flex-row justify-between items-center border-b mb-4">
                        <h3 className="modal-title text-xl font-bold">プライバシーポリシー</h3>
                        <button
                            className="close text-2xl font-bold cursor-pointer"
                            onClick={onClose}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="privacy-policy-content">
                        {customerLegal.isLoading && <Loading />}
                        {customerLegal.error && <p className="text-red-500">エラーが発生しました: {customerLegal.error}</p>}
                        {customerLegal.privacyPolicy && (
                            <div 
                                className="whitespace-pre-wrap text-sm leading-relaxed"
                                dangerouslySetInnerHTML={{
                                    __html: customerLegal.privacyPolicy || 'プライバシーポリシーが設定されていません。'
                                }}
                            />
                        )}
                    </div>
                    <div className='flex flex-row justify-center mt-6'>
                        <div className='m-[10px]'>
                            <Button
                                label={'同意して閉じる'}
                                onClick={() => {
                                    if (onConfirm) onConfirm();
                                    onClose();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyModal;
